var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoInfographic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M493.526,0H18.474C8.288,0,0,8.288,0,18.474v475.052C0,503.712,8.288,512,18.474,512h475.052 c10.186,0,18.474-8.288,18.474-18.474V18.474C512,8.288,503.712,0,493.526,0z M496.165,493.526c0,1.43-1.209,2.639-2.639,2.639 H18.474c-1.43,0-2.639-1.209-2.639-2.639V18.474c0-1.43,1.209-2.639,2.639-2.639h475.052c1.43,0,2.639,1.209,2.639,2.639V493.526z "
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256,42.227c-94.591,0-171.546,76.955-171.546,171.546S161.409,385.32,256,385.32s171.546-76.955,171.546-171.546 S350.591,42.227,256,42.227z M263.918,58.261c79.572,4.005,143.589,68.022,147.594,147.594h-31.73 c-3.932-62.102-53.762-111.932-115.864-115.864V58.261z M364.206,213.773c0,59.665-48.541,108.206-108.206,108.206 c-59.665,0-108.206-48.541-108.206-108.206c0-59.665,48.541-108.206,108.206-108.206 C315.665,105.567,364.206,154.108,364.206,213.773z M256,369.485c-85.86,0-155.711-69.852-155.711-155.711 c0-83.205,65.599-151.375,147.794-155.512v31.73c-64.72,4.098-116.124,58.045-116.124,123.782 c0,68.397,55.644,124.041,124.041,124.041c65.737,0,119.683-51.403,123.782-116.124h31.73 C407.375,303.886,339.205,369.485,256,369.485z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256,137.237c-42.203,0-76.536,34.334-76.536,76.536s34.334,76.536,76.536,76.536s76.536-34.334,76.536-76.536 S298.203,137.237,256,137.237z M256,274.474c-33.471,0-60.701-27.23-60.701-60.701s27.23-60.701,60.701-60.701 s60.701,27.23,60.701,60.701S289.471,274.474,256,274.474z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 50.144,
    y: 432.825,
    width: 95.01,
    height: 15.835
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 366.845,
    y: 432.825,
    width: 95.01,
    height: 15.835
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 160.99,
    y: 432.825,
    width: 21.113,
    height: 15.835
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 197.938,
    y: 432.825,
    width: 21.113,
    height: 15.835
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 234.887,
    y: 432.825,
    width: 21.113,
    height: 15.835
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 50.144,
    y: 395.876,
    width: 73.897,
    height: 15.835
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 409.072,
    y: 395.876,
    width: 52.784,
    height: 15.835
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoInfographic);
export default __webpack_public_path__ + "static/media/ico-infographic.8cfd8e95.svg";
export { ForwardRef as ReactComponent };